var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5326",
    "data-name": "Group 5326",
    transform: "translate(-404.5 -291.757)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Base",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(405 292.257)",
    fill: "#FF3535",
    stroke: "#FF3535",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "phone-svgrepo-com",
    d: "M13.15,16.531c-1.867,0-4.258-1.444-7.107-4.293-2.23-2.23-3.607-4.2-4.094-5.843a4.032,4.032,0,0,1-.16-1.766,2.508,2.508,0,0,1,.42-1.064h0c.178-.271,1.262-1.815,2.74-1.815a2.3,2.3,0,0,1,1.475.567A5.282,5.282,0,0,1,8.384,4.8a2.514,2.514,0,0,1-.261,1.757,1.854,1.854,0,0,0-.239,1.053A3.281,3.281,0,0,0,9.012,9.251a3.126,3.126,0,0,0,1.909,1.073,2.244,2.244,0,0,0,.877-.24,2.922,2.922,0,0,1,1.159-.3c.9,0,1.826.639,3,2.071a2.222,2.222,0,0,1,.53,1.877,4.145,4.145,0,0,1-1.778,2.341A2.643,2.643,0,0,1,13.15,16.531ZM2.983,4.066q-.011.018-.023.036a2.276,2.276,0,0,0-.126,2.032c.443,1.5,1.742,3.332,3.862,5.452,3.325,3.325,5.345,4.023,6.454,4.023a1.731,1.731,0,0,0,1.03-.287l.036-.023a3.333,3.333,0,0,0,1.373-1.757,1.326,1.326,0,0,0-.34-1.1c-.96-1.166-1.71-1.733-2.292-1.733a2.112,2.112,0,0,0-.8.226,3.075,3.075,0,0,1-1.235.313A3.871,3.871,0,0,1,8.378,9.922,4.032,4.032,0,0,1,6.973,7.751a2.668,2.668,0,0,1,.3-1.568,1.675,1.675,0,0,0,.214-1.157,4.589,4.589,0,0,0-1.653-2,1.385,1.385,0,0,0-.889-.357C3.906,2.673,3.007,4.028,2.983,4.066Z",
    transform: "translate(411.711 298.968)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.35971437f3791f78f25ded93be742b44.svg";
export { ForwardRef as ReactComponent };